import { useAppStore } from "@/components/AppHooks"
import { IconAlcohol, IconNoAlcohol } from "@/components/icon/master"
import { DdpCta } from "@/components/shared/DdpCta"
import { Popup } from "@/components/shared/Popup"

export function PopupQuizChooseAlcohol(props: any) {
    const { content, show, onClose } = props
    const { alcohol, setAlcohol } = useAppStore()
    return <Popup className='popup-quiz-choose-alcohol' show={show} onClose={onClose}>
        <h2 className="choose-title">{content.title}</h2>
        <div className="choose-content-wrapper">
            <div className={`content-item ${alcohol === true ? 'selected' : ''}`} onClick={() => {
                setAlcohol(true)
            }}>
                <IconAlcohol className="icon-alcohol" />
                <div className="content-text">{content.answerAlcohol}</div>
            </div>
            <div className={`content-item ${alcohol === false ? 'selected' : ''}`} onClick={() => {
                setAlcohol(false)
            }}>
                <IconNoAlcohol className="icon-alcohol" />
                <div className="content-text">{content.answerNoAlcohol}</div>
            </div>

        </div>
        <DdpCta className="popup-cta" disabled={alcohol === undefined} cta={content.cTAContinue} />
    </Popup>
}